export const sdLimitList = ['period_056_SD', 'period_057_SD', 'period_058_SD']